import { AppUser } from '../types';

const storageKey = 'appUser';

export default {
  read(): AppUser|null {
    const appUser = window.localStorage.getItem(storageKey);
    if (appUser) return JSON.parse(appUser);
    return null;
  },
  write(appUser: AppUser) {
    window.localStorage.setItem(storageKey, JSON.stringify(appUser));
  },
  clear() {
    window.localStorage.removeItem(storageKey);
  },
};
